import { getFromLocalStorage } from '../utils/localStorage'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  subcategories: [],
  isSubscribed: getFromLocalStorage('transactionalData')?.isSubscribed,
  deviceDetails: getFromLocalStorage('deviceDetails', []),
  requiredDetails: {},
  ipidUrl: {},
  otherRelatedDocsUrl: {},
}

const subscriptionSlice = createSlice({
  name: 'subscriptionSlice',
  initialState,
  reducers: {
    setSubcategories: (state, action) => {
      state.subcategories = action.payload
    },
    setPlanDetails: (state, action) => {
      state.planDetails = action.payload
    },
    setPlanDocuments: (state, action) => {
      state.planDocuments = action.payload
    },
    setSubscriptionError: (state, action) => {
      state.subscriptionError = action.payload
    },
    setErrors: (state, action) => {
      state.errors = action.payload
    },
    setIsSubscribed: (state, action) => {
      state.isSubscribed = action.payload
    },
    setCurrentAddress: (state, action) => {
      state.currentAddress = action.payload
    },
    setDeviceDetails: (state, action) => {
      state.deviceDetails = action.payload
    },
    setRequiredDetails: (state, action) => {
      state.requiredDetails = action.payload
    },
    setEnrollmentPlanList: (state, action) => {
      state.enrollmentPlanList = action.payload
    },
    setIpIdUrl: (state, action) => {
      state.ipidUrl = action.payload
    },
    setOtherRelatedDocsUrl: (state, action) => {
      state.otherRelatedDocsUrl = action.payload
    },
  },
})

export default subscriptionSlice.reducer

export const {
  setSubcategories,
  setPlanDetails,
  setPlanDocuments,
  setSubscriptionError,
  setErrors,
  setIsSubscribed,
  setCurrentAddress,
  setDeviceDetails,
  setRequiredDetails,
  setEnrollmentPlanList,
  setIpIdUrl,
  setOtherRelatedDocsUrl,
} = subscriptionSlice.actions
